/**
 * Installer for the HRM Attendance Agent (desktop app that reads punch devices on the LAN).
 * REACT_APP_ATTENDANCE_AGENT_DOWNLOAD_URL overrides it per environment.
 */
export const ATTENDANCE_AGENT_DOWNLOAD_URL =
  String(process.env.REACT_APP_ATTENDANCE_AGENT_DOWNLOAD_URL || "").trim() ||
  "https://downloads.timeoffledger.com/agent/HRM-Attendance-Agent-Setup-latest.exe";
